import Hero from 'components/Hero'
import VideoBanner from 'components/VideoBanner'
import NftSlider from 'components/NftSlider'
import RoadMap from 'components/RoadMap'
import Token from 'components/Token'
import Features from "components/Features";
import Whitepaper from 'components/Whitepaper'
import Faqs from 'components/Faq'
import Team from 'components/OurTeam'
import JoinCommunity from 'components/Join'
import News from 'components/news'

// ============= Home container ==================
const Home = () => {
    return (
        <main>
            <Hero />
            <VideoBanner/>
            <NftSlider />
            <RoadMap />
            <Features />
            <Token />
            <News/>
            <Whitepaper />
            <Faqs />
            <Team />
            <JoinCommunity />
        </main>
    )
}

export default Home
